module.exports = __webpack_public_path__ + "static/turquia-015-e989b19260c199dbad640e50204754b0.jpg";